const PricingProps = [
    {
        id: "1",
        title: "Free",
        imgSrc: "imgs/scooter.svg",
        currency: "$",
        price: "0.00/Month",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae aliquid ad provident aut fuga animi soluta quae eos non cupiditate voluptates dolorem, doloremque quos dicta quibusdam impedit iure nemo a iste.",
    },
    {
        id: "2",
        title: "Basic",
        imgSrc: "imgs/shipped.svg",
        currency: "$",
        price: "9.99/Month",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae aliquid ad provident aut fuga animi soluta quae eos non cupiditate voluptates dolorem, doloremque quos dicta quibusdam impedit iure nemo a iste.",
    },
    {
        id: "3",
        title: "Premium",
        imgSrc: "imgs/startup.svg", 
        currency: "$",
        price: "14.99/Month",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae aliquid ad provident aut fuga animi soluta quae eos non cupiditate voluptates dolorem, doloremque quos dicta quibusdam impedit iure nemo a iste.",
    },
]

export default PricingProps;